export const userMockData = [
        {
		    patientId: 1,
			institutionId: 1,
			interviewDetailId: 1,
			patientName: "",
			currentQuestionNumber: 0
		}
	]

export const answerMockData = [
	{
		m_template_id: 1,
		interviewDetailId: 1,
		isComplete: false,
		isEditMode: false,
		isRegistered: false,
		questions: [
			{
				partGroupId: 1,
				answers: [
					{ partFieldId: 1, value: "", label: "", formName: "", arrValue: [], imgValue: [{fileType: "", fileName: "", imgPath: "", }],isAnswerRequired: false},
					{ partFieldId: 2, value: "", label: "", formName: "", arrValue: [], imgValue: [{fileType: "", fileName: "", imgPath: "", }],isAnswerRequired: false},
				]
			}
		]
	}
]

export const QuestionMockData = [
	{
		interviewDetailId: 1,
		interviewContents: [
			{
				questionNumber: 0,
				templateId: 1,
				categoryId: 1,
				title: "" ,
				shortTitle: "",
				questionGroupId: 1,
				parts: [
					{
						formName: "",
						placeholder: "",
						options: []
					},
					{	
						formName: "",
						placeholder: "",
						options: []
					}
				] 
			}
		]
	}
]

export const categoryMock = [
	{
		interviewDetailId: 1,
		categories: [
			{ partGroupId: 1, categoryName: "" }
		]
	}
]